import { render, staticRenderFns } from "./report-card-small.vue?vue&type=template&id=be04a9ae&scoped=true"
import script from "./report-card-small.vue?vue&type=script&lang=js"
export * from "./report-card-small.vue?vue&type=script&lang=js"
import style0 from "./report-card-small.vue?vue&type=style&index=0&id=be04a9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be04a9ae",
  null
  
)

export default component.exports